import { NoMatchPage } from "components/NoMatchPage";
import { FC } from "react";
import { Route, Routes } from "react-router-dom";

import { StockPage } from "./StockPage";

const Router: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<StockPage />} />
      <Route path="*" element={<NoMatchPage />} />
    </Routes>
  );
};
export default Router;
